import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';
import { colors, spacer, fontWeight, media } from 'settings/style';

export const MenuLink = styled(NavLink)`
  color: #3f4a5d;
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  padding: ${spacer.sm} ${spacer.md};
  border-bottom: 3px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: ${colors.accent};
    border-bottom-color: ${colors.accent};
  }

  &.selected {
    color: ${colors.accent};
    border-bottom-color: ${colors.accent};
  }
`;

export const LogoDesktopImg = styled.img`
  width: 280px;
  max-width: 100%;
  display: block;

  ${media.md`
    display: none;
  `}
`;

export const LogoMobileImg = styled.img`
  width: 87px;
  max-width: 100%;
  display: none;

  ${media.md`
    display: block;
  `}
`;

export const ProfileDropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const ProfileButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  color: ${colors.grey900};
  font-weight: ${fontWeight.bold};
  font-size: 17px;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const UserAvatarIcon = styled(UserOutlined)`
  font-size: 16px;
`;

export const AvatarImg = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
`;

export const ProfileMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  z-index: 1000;
`;

export const MenuItem = styled.button`
  display: block;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 15px;
  color: #1f2937;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f3f4f6;
  }
`;

interface HeaderWrapperProps {
  light: boolean;
  isLoggedIn?: boolean;
  scrollPos: number;
}

export const HeaderWrapper = styled.header<HeaderWrapperProps>`
  ${({ light, isLoggedIn, scrollPos }) => css`
    /* Fixed on home (light) so nav stays over the hero while scrolling; sticky elsewhere */
    position: ${light ? 'fixed' : 'sticky'};
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    padding: 10px 0;
    background-color: white;
    border-bottom: ${isLoggedIn || !light || scrollPos > 0 ? '1px solid #d6dbe4' : '0'};

    .mobile-menu {
      display: none;
      padding: 0px 10px;
      margin: 0 auto;
      
      // Custom TabBar selected text color
      .adm-tab-bar-item {
        padding-top: 10px;
      }

      .adm-tab-bar-item-active {
        color: ${colors.primary500} !important;
        border-top: 3px solid ${colors.primary500};
      }
      
      .adm-tab-bar-item-title {
        color: ${colors.gray600};
        font-weight: bold;
        font-size: 12px;
      }
      
      .adm-tab-bar-item-active .adm-tab-bar-item-title {
        color: ${colors.primary500} !important;
      }
    }

    ${media.md`
      background-color: ${isLoggedIn || scrollPos > 0 ? 'white' : 'transparent'};
      border-bottom: ${isLoggedIn || scrollPos > 0 ? '1px solid #d6dbe4' : '0'};
      .mobile-menu{
        display: block;
        position: fixed;
        bottom: 0;
        background-color: white;
        width: 100%;
        padding-bottom: 20px; 
      }
    `}

    .header-row {
      flex-direction: row;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 50px;
      .logo-cont {
        ${media.lg`
          flex: 1;
        `}
      }
      .hamburger-menu {
        ${media.lg`
          flex: 1;
          text-align: left;
        `}
        display: none;
        color: white;
        ${media.lg`
          display: block;
        `}
      }
      .menu-container {
        align-items: center;
        gap: ${spacer.xl};
        .login-signup {
          align-items: center;
          display: flex;
          gap: ${spacer.sm};

          .btn-signup,
          .btn-signin {
            height: 40px;
            min-width: 108px;
            border-radius: 12px;
            font-size: 17px;
            font-weight: ${fontWeight.bold};
          }

          .btn-signup {
            background-color: white;
            color: #1f2937;
            border: 1px solid #D0D5DD;

            .logout-icon {
              display: none;
            }

            &.logout-btn {
              ${media.md`
                display: none;
              `}
            }
          }

          .btn-signin {
            background-color: ${colors.accent};
            color: #1f2937;
            border: 1px solid ${colors.accent};
          }
        }
        ${media.lg`
          flex: 1;
          justify-content: flex-end;
        `}

        display: flex;
        .menu-links {
          ${media.lg`
            display: none;
          `}
          display: flex;
          .menu-links__item {
            margin: 0 ${spacer.xs};
          }
        }
      }
    }
  `}
`;